import { DbDeleteBrekageReport } from "../../../data/usecases/delete-brekage-report";
import { DeleteBreakageReport } from "../../../domain/usecases/delete-brekage-report";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbDeleteBreakageReport = (): DeleteBreakageReport =>
  new DbDeleteBrekageReport(
    makeApiUrl("/breakage"),
    makeAuthorizeHttpClientDecorator()
  );
